var GalleryOptions_Layout_Type = /* @__PURE__ */ ((GalleryOptions_Layout_Type2) => {
  GalleryOptions_Layout_Type2["COLLAGE"] = "COLLAGE";
  GalleryOptions_Layout_Type2["MASONRY"] = "MASONRY";
  GalleryOptions_Layout_Type2["GRID"] = "GRID";
  GalleryOptions_Layout_Type2["THUMBNAIL"] = "THUMBNAIL";
  GalleryOptions_Layout_Type2["SLIDER"] = "SLIDER";
  GalleryOptions_Layout_Type2["SLIDESHOW"] = "SLIDESHOW";
  GalleryOptions_Layout_Type2["PANORAMA"] = "PANORAMA";
  GalleryOptions_Layout_Type2["COLUMN"] = "COLUMN";
  GalleryOptions_Layout_Type2["MAGIC"] = "MAGIC";
  GalleryOptions_Layout_Type2["FULLSIZE"] = "FULLSIZE";
  GalleryOptions_Layout_Type2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return GalleryOptions_Layout_Type2;
})(GalleryOptions_Layout_Type || {});
var GalleryOptions_Layout_Orientation = /* @__PURE__ */ ((GalleryOptions_Layout_Orientation2) => {
  GalleryOptions_Layout_Orientation2["ROWS"] = "ROWS";
  GalleryOptions_Layout_Orientation2["COLUMNS"] = "COLUMNS";
  GalleryOptions_Layout_Orientation2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return GalleryOptions_Layout_Orientation2;
})(GalleryOptions_Layout_Orientation || {});
var GalleryOptions_ItemStyle_Crop = /* @__PURE__ */ ((GalleryOptions_ItemStyle_Crop2) => {
  GalleryOptions_ItemStyle_Crop2["FILL"] = "FILL";
  GalleryOptions_ItemStyle_Crop2["FIT"] = "FIT";
  GalleryOptions_ItemStyle_Crop2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return GalleryOptions_ItemStyle_Crop2;
})(GalleryOptions_ItemStyle_Crop || {});
var GalleryOptions_Thumbnails_Alignment = /* @__PURE__ */ ((GalleryOptions_Thumbnails_Alignment2) => {
  GalleryOptions_Thumbnails_Alignment2["TOP"] = "TOP";
  GalleryOptions_Thumbnails_Alignment2["RIGHT"] = "RIGHT";
  GalleryOptions_Thumbnails_Alignment2["BOTTOM"] = "BOTTOM";
  GalleryOptions_Thumbnails_Alignment2["LEFT"] = "LEFT";
  GalleryOptions_Thumbnails_Alignment2["NONE"] = "NONE";
  GalleryOptions_Thumbnails_Alignment2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return GalleryOptions_Thumbnails_Alignment2;
})(GalleryOptions_Thumbnails_Alignment || {});
export {
  GalleryOptions_ItemStyle_Crop,
  GalleryOptions_Layout_Orientation,
  GalleryOptions_Layout_Type,
  GalleryOptions_Thumbnails_Alignment
};
//# sourceMappingURL=plugin_gallery.enums.js.map
